import { Organisation } from '~organisations/domain';

import genericAdditionalFields from './additionalOutcomeCaptureFields/generic';
import logo from './images/logo.png';

const auspostConfig: Organisation = {
  logo: logo,
  additionalOutcomeCaptureFields: {
    '13': genericAdditionalFields,
    '18': genericAdditionalFields,
    '19': genericAdditionalFields,
  },
  asyncAdditionalOutcomeCaptureFields: {},
  contactAssessmentForms: {},
};

export default auspostConfig;
